<div class="row page-header">
    <div class="col-12">
        <h1>Tire Management <small>(Beta) Vendors, routes, and per-equipment tire sizes</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs mb-3">
        <li [ngbNavItem]="1">
            <a ngbNavLink>Vendors</a>
            <ng-template ngbNavContent>
                <div class="row action-toolbar">
                    <div class="col-12">
                        <form class="form-inline">
                            <action-toolbar-count [grid]="vendorGrid"></action-toolbar-count>
                            <action-toolbar-buttons
                                [grid]="vendorGrid"
                                [canEdit]="canEdit"
                                [showAdd]="true"
                                [showEdit]="true"
                                [showDelete]="true"
                            ></action-toolbar-buttons>
                            <action-toolbar-search name="vendorSearch" [(ngModel)]="vendorGrid.filter"></action-toolbar-search>
                        </form>
                    </div>
                </div>
                <wj-flex-grid
                    #gridVendors
                    appAutoSize
                    (initialized)="vendorGrid.initialize(gridVendors)"
                    (destroy)="vendorGrid.destroy()"
                    [itemsSource]="vendorGrid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Location'" [binding]="'resolvedLocation'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Contact'" [binding]="'resolvedContactName'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Phone'" [binding]="'resolvedPhone'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Email'" [binding]="'resolvedEmail'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Source'" [binding]="'contactSource'" [width]="'*'"></wj-flex-grid-column>
                </wj-flex-grid>
            </ng-template>
        </li>
        <li [ngbNavItem]="2">
            <a ngbNavLink>Vendor Routes</a>
            <ng-template ngbNavContent>
                <div class="row action-toolbar">
                    <div class="col-12">
                        <form class="form-inline">
                            <action-toolbar-count [grid]="routeGrid"></action-toolbar-count>
                            <action-toolbar-buttons
                                [grid]="routeGrid"
                                [canEdit]="canEdit"
                                [showAdd]="true"
                                [showEdit]="true"
                                [showDelete]="true"
                            ></action-toolbar-buttons>
                            <action-toolbar-search name="routeSearch" [(ngModel)]="routeGrid.filter"></action-toolbar-search>
                        </form>
                    </div>
                </div>
                <wj-flex-grid
                    #gridRoutes
                    appAutoSize
                    (initialized)="routeGrid.initialize(gridRoutes)"
                    (destroy)="routeGrid.destroy()"
                    [itemsSource]="routeGrid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'County'" [binding]="'countyDisplay'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Class'" [binding]="'equipmentClass'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Rank'" [binding]="'rank'" [width]="80"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Vendor'" [binding]="'tireVendorName'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Location'" [binding]="'vendorLocation'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Phone'" [binding]="'vendorPhone'" [width]="'*'"></wj-flex-grid-column>
                </wj-flex-grid>
            </ng-template>
        </li>
        <li [ngbNavItem]="3">
            <a ngbNavLink>Equipment Tire Config</a>
            <ng-template ngbNavContent>
                <div class="row action-toolbar">
                    <div class="col-12">
                        <form class="form-inline">
                            <action-toolbar-count [grid]="configGrid"></action-toolbar-count>
                            <action-toolbar-buttons
                                [grid]="configGrid"
                                [canEdit]="canEdit"
                                [showAdd]="true"
                                [showEdit]="true"
                                [showDelete]="true"
                            ></action-toolbar-buttons>
                            <action-toolbar-search name="configSearch" [(ngModel)]="configGrid.filter"></action-toolbar-search>
                        </form>
                    </div>
                </div>
                <wj-flex-grid
                    #gridConfigs
                    appAutoSize
                    (initialized)="configGrid.initialize(gridConfigs)"
                    (destroy)="configGrid.destroy()"
                    [itemsSource]="configGrid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Axle'" [binding]="'axleNumber'" [width]="80"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Side'" [binding]="'side'" [width]="100"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Tire size'" [binding]="'tireSize'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Label'" [binding]="'positionLabel'" [width]="'*'"></wj-flex-grid-column>
                </wj-flex-grid>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
</div>
